import React, { useState } from 'react';
import './OddsInput.css';

function OddsInput({ fight, onClose }) {
  const [oddsA, setOddsA] = useState('');
  const [oddsB, setOddsB] = useState('');
  const [bookmaker, setBookmaker] = useState('DraftKings');

  const handleSubmit = async () => {
    try {
      // Add odds for fighter A if provided
      if (oddsA) {
        await fetch(`/api/fight/${fight.fight_id}/add-odds`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            fighter_id: fight.fighter_a_id,
            odds_american: parseInt(oddsA),
            bookmaker
          })
        });
      }

      // Add odds for fighter B if provided
      if (oddsB) {
        await fetch(`/api/fight/${fight.fight_id}/add-odds`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            fighter_id: fight.fighter_b_id,
            odds_american: parseInt(oddsB),
            bookmaker
          })
        });
      }

      onClose();
    } catch (error) {
      console.error('Error adding odds:', error);
      alert('Error adding odds');
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Add Odds</h3>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>

        <div className="modal-body">
          <div className="fight-info">
            <h4>{fight.fighter_a} vs {fight.fighter_b}</h4>
            <p>{fight.event_name}</p>
          </div>

          <div className="odds-form">
            <div className="form-group">
              <label>Bookmaker</label>
              <select value={bookmaker} onChange={(e) => setBookmaker(e.target.value)}>
                <option>DraftKings</option>
                <option>FanDuel</option>
                <option>BetMGM</option>
                <option>Caesars</option>
                <option>PointsBet</option>
                <option>Other</option>
              </select>
            </div>

            <div className="odds-inputs">
              <div className="form-group">
                <label>{fight.fighter_a} Odds (American)</label>
                <input
                  type="number"
                  placeholder="+200 or -150"
                  value={oddsA}
                  onChange={(e) => setOddsA(e.target.value)}
                />
                <small>Current: {fight.prob_a}% probability</small>
              </div>

              <div className="form-group">
                <label>{fight.fighter_b} Odds (American)</label>
                <input
                  type="number"
                  placeholder="+200 or -150"
                  value={oddsB}
                  onChange={(e) => setOddsB(e.target.value)}
                />
                <small>Current: {fight.prob_b}% probability</small>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleSubmit}
            disabled={!oddsA && !oddsB}
          >
            Add Odds
          </button>
        </div>
      </div>
    </div>
  );
}

export default OddsInput;
